import { useState, useEffect, useRef } from 'react'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { useNavigate } from 'react-router-dom'
import { BlogCampaignForm } from '../components/BlogCampaignForm'
import { Loading } from '../components/ui/Loading'
import { CampaignAPI } from '../api/CampaignAPI'
import { ProgressError } from '../components/ui/ProgressError'
import { TemplateLibrary } from '../components/TemplateLibrary'
import { CampaignAssetUploader } from '../components/CampaignAssetUploader'
import { fabric } from 'fabric'

const MAX_TEMPLATES = 5
export const BlogCampaign = () => {
    const [loadState, setLoadState] = useState({
        loading: false,
        msg: null,
    })
    const [isError, setIsError] = useState({ state: false })
    const [step, setStep] = useState(0)
    const [templates, setTemplates] = useState(null)
    const blogPost = useRef(null)
    const campaignId = useRef(null)
    const navigate = useNavigate()

    const createCampaign = (templates) => {
        CampaignAPI.createBlogCampaign(blogPost.current.id)
            .then((response) => {
                campaignId.current = response.data.id
                setStep(2)
                setTemplates(templates)
            })
            .catch((response) => {
                setIsError({ state: true, msg: 'An error occurred...' })
            })
    }

    const saveBlogPost = (title, articleId) => {
        setLoadState({
            loading: true,
            msg: 'Saving article data...',
        })
        CampaignAPI.createBlogPost(title, articleId)
            .then((response) => {
                blogPost.current = response.data
                setLoadState({ loading: false })
                setStep(1)
            })
            .catch((response) => {
                setIsError({ state: true, msg: 'An error occurred...' })
            })
    }

    const extractArticle = ({ title, url }) => {
        setLoadState({
            loading: true,
            msg: 'Scanning url...',
        })
        CampaignAPI.extractBlog(url)
            .then((response) => {
                if (response.data.status === 'ok') {
                    saveBlogPost(title, response.data.id)
                } else {
                    setIsError({ state: true, msg: response.data.reason })
                }
            })
            .catch((response) => {
                setIsError({ state: true, msg: 'An error occurred...' })
            })
    }

    let body = null
    if (isError.state == true) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <ProgressError
                    msg={isError.msg}
                    path="/merchant/calendar_v2/"
                />
            </Box>
        )
    } else if (loadState.loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Loading message={loadState.msg} />
            </Box>
        )
    }

    if (step == 0) {
        body = (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography level="h2" color="neutral">
                    Create Blog Campaign
                </Typography>
                <BlogCampaignForm onSubmit={extractArticle} />
            </Box>
        )
    } else if (step == 1) {
        body = (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <TemplateLibrary
                    onSubmit={createCampaign}
                    maxItems={MAX_TEMPLATES}
                />
            </Box>
        )
    } else if (step == 2) {
        body = (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CampaignAssetUploader
                    article={blogPost.current.article}
                    campaignId={campaignId.current}
                    templates={templates}
                    onStatusChanged={() =>
                        navigate(
                            `/merchant/view_campaign_v2/${campaignId.current}`
                        )
                    }
                />
            </Box>
        )
    }

    return body
}
